import { GlobalAxios } from "./../axios/axios-config";
import {
  INewTicketAutomationReceivedRuleOfferClassif,
  ITicketAutomationReceivedRuleOfferClassif,
} from "../models/ticket-aut-rec-rule-offer-classif";

const TICKET_AUTOMATION_RECEIVED_RULE_OFFER_CLASSIF_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleOfferClassif/";

export const createTicketAutomationReceivedRuleOfferClassif = (
  item: INewTicketAutomationReceivedRuleOfferClassif,
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULE_OFFER_CLASSIF_ROUTE,
    item,
  );
};

export const getTicketAutomationReceivedRuleOfferClassifById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedRuleOfferClassif>(
    TICKET_AUTOMATION_RECEIVED_RULE_OFFER_CLASSIF_ROUTE + id,
  );
};

export const updateTicketAutomationReceivedRuleOfferClassifById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedRuleOfferClassif;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULE_OFFER_CLASSIF_ROUTE + id,
    item,
  );
};
